import { CreateClientParams } from 'contentful'

const config: CreateClientParams = {
  space: process.env.VUE_APP_QUESTIONS_SPACE || '',
  accessToken: process.env.VUE_APP_QUESTIONS_TOKEN || '',
  environment: process.env.VUE_APP_QUESTIONS_ENV || 'master',
}

export default config
